import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding: 10px;
`;

export const HeaderTitle = styled.h1`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin: 0;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  cursor: pointer;
`;
